import { DatePipe } from '@angular/common';
import { Component, signal, Signal, WritableSignal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { ContractType } from '@app-model/api';
import { UserResponse } from '@app-model/login';
import { selectUser } from '@app-store/user/user.selectors';

@Component({
  templateUrl: './remit-print-template.component.html',
  styleUrls: ['./remit-print-template.component.scss'],
  imports: [DatePipe, TranslateModule],
})
export class RemitPrintTemplateComponent {
  private store = inject(Store);

  contracts: WritableSignal<ContractType[]> = signal([]);
  remitted: WritableSignal<boolean> = signal(false);
  navbarLogo: WritableSignal<string | ArrayBuffer> = signal('');
  totalDealerCost: WritableSignal<number> = signal(0);

  user: Signal<UserResponse> = toSignal(this.store.select(selectUser));
  date: Date = new Date();
  readonly amountOfContractOnFirstPage: number = 10;
  readonly amountOfContractOnRestPages: number = 22;
}
